import { logTrace } from './logger';
import { APIScenarioNames } from '../constants';

let previewBarVisibility;
let onVisibilityChangeHandler;

const getVisibility = () => previewBarVisibility;

const handlePreviewBarVisibilityChange = () => onVisibilityChangeHandler
  && onVisibilityChangeHandler(getVisibility());

const onVisibilityChange = (handler) => {
  onVisibilityChangeHandler = handler;
};

const unbindVisibility = (handler) => {
  if (onVisibilityChangeHandler === handler) {
    onVisibilityChangeHandler = undefined;
  }
};

const setVisibility = (visibility) => {
  previewBarVisibility = visibility;
  handlePreviewBarVisibilityChange();
  logTrace(APIScenarioNames.setPreviewBarVisibility, String(visibility));
};

export {
  // for internal use
  getVisibility, onVisibilityChange, unbindVisibility,
  // for external use
  setVisibility
};
